import { TCommunityDetailsForm } from 'components/Forms/forms.communityDetails.d'
import { CommunityData } from '../Communities/CommunityDetails/types'

export const mapCommunityDetailsToForm = (
  data: CommunityData
): TCommunityDetailsForm => ({
  uuid: data.uuid,
  name: data.name,
  description: data.description,
  gpo_relation: data.gpo_relation?.uuid,
  legal_name: data.legal_name,
  moov_business_account: data.moov_business_account
})
